import { TitledCheckbox } from '../../../components/form/TitledCheckbox';
import * as React from 'react';
import { ReactNode } from 'react';
import { CheckboxChangeEvent } from 'primereact/checkbox';

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  invalid?: boolean;
  required?: boolean;
  disabled?: boolean;
  label: string;
}

export const Hidden = (props: Props): ReactNode => {
  return <TitledCheckbox
    title={props.label}
    inputId={'hidden'}
    checked={props.checked || false}
    disabled={props.disabled}
    invalid={props.invalid}
    required={props.required}
    onChange={(e: CheckboxChangeEvent): void => props.onChange(e.checked)}
  />;
};
